"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadInitialElementsPageSaga = exports.loadInitialElementsPageWorker = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
// eslint-disable-next-line import/no-unassigned-import
require("abortcontroller-polyfill/dist/abortcontroller-polyfill-only");
var sagas_1 = require("../common/sagas");
var selectors_1 = require("../common/selectors");
var elementsSaga_1 = require("../elements/elementsSaga");
var elementsSelectors_1 = require("../elements/elementsSelectors");
var slice_1 = require("../store/slice");
var loadLimitingAttributeFiltersAttributes_1 = require("./loadLimitingAttributeFiltersAttributes");
/**
 * @internal
 */
function loadInitialElementsPageWorker() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest([slice_1.actions.loadInitialElementsPageRequest.match, slice_1.actions.loadInitialElementsPageCancelRequest.match], loadInitialElementsPageSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.loadInitialElementsPageWorker = loadInitialElementsPageWorker;
/**
 * @internal
 */
function loadInitialElementsPageSaga(action) {
    var context, abortController, correlation, loadOptions, elementsForm, loadOptionsWithExcludePrimaryLabel, result, limitingAttributeFiltersAttributes, error_1;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.call(sagas_1.getAttributeFilterContext)];
            case 1:
                context = _b.sent();
                abortController = new AbortController();
                correlation = action.payload.correlation;
                _b.label = 2;
            case 2:
                _b.trys.push([2, 10, 12, 16]);
                if (slice_1.actions.loadInitialElementsPageCancelRequest.match(action)) {
                    // Saga was triggered by cancel request - do nothing, just jump to finally statement
                    return [2 /*return*/];
                }
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadInitialElementsPageStart({ correlation: correlation }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, effects_1.select(elementsSelectors_1.selectLoadElementsOptions)];
            case 4:
                loadOptions = _b.sent();
                return [4 /*yield*/, effects_1.select(selectors_1.selectElementsForm)];
            case 5:
                elementsForm = _b.sent();
                loadOptionsWithExcludePrimaryLabel = tslib_1.__assign(tslib_1.__assign({}, loadOptions), { signal: abortController.signal, excludePrimaryLabel: !context.backend.capabilities.supportsElementUris && elementsForm === "values" });
                return [4 /*yield*/, effects_1.call(elementsSaga_1.elementsSaga, loadOptionsWithExcludePrimaryLabel)];
            case 6:
                result = _b.sent();
                return [4 /*yield*/, effects_1.call(loadLimitingAttributeFiltersAttributes_1.loadLimitingAttributeFiltersAttributes, context, (_a = loadOptions.limitingAttributeFilters) !== null && _a !== void 0 ? _a : [])];
            case 7:
                limitingAttributeFiltersAttributes = _b.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.setLimitingAttributeFiltersAttributes({ attributes: limitingAttributeFiltersAttributes }))];
            case 8:
                _b.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadInitialElementsPageSuccess(tslib_1.__assign(tslib_1.__assign({}, result), { correlation: correlation })))];
            case 9:
                _b.sent();
                return [3 /*break*/, 16];
            case 10:
                error_1 = _b.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadInitialElementsPageError({
                        error: error_1,
                        correlation: correlation,
                    }))];
            case 11:
                _b.sent();
                return [3 /*break*/, 16];
            case 12: return [4 /*yield*/, effects_1.cancelled()];
            case 13:
                if (!_b.sent()) return [3 /*break*/, 15];
                abortController.abort();
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadInitialElementsPageCancel({ correlation: correlation }))];
            case 14:
                _b.sent();
                _b.label = 15;
            case 15: return [7 /*endfinally*/];
            case 16: return [2 /*return*/];
        }
    });
}
exports.loadInitialElementsPageSaga = loadInitialElementsPageSaga;
//# sourceMappingURL=loadInitialElementsPageSaga.js.map